/**
 * Every number Meta reports for an ad and an ad set (notes/AUDIENCE.md 7.5). Flashadz asks for all of
 * them and keeps them as Meta sends them; the agent reads all of them; the app shows the main ones and
 * the owner adds any other.
 */

/** Meta's Ads Insights fields, from Meta's own business SDK (`AdsInsights.Field`), read 2 Oct 2026. */
export const META_INSIGHT_FIELDS = [
  "account_currency", "account_id", "account_name", "action_values", "actions", "ad_click_actions", "ad_id",
  "ad_impression_actions", "ad_name", "adset_end", "adset_id", "adset_name", "adset_start", "advanced_actions_28d_view",
  "advanced_reach_1d_lookback", "advanced_reach_28d_lookback", "advanced_reach_7d_lookback", "age_targeting",
  "anchor_event_attribution_setting", "anchor_events_performance_indicator", "attribution_setting", "auction_bid",
  "auction_competitiveness", "auction_max_competitor_bid", "average_purchases_conversion_value", "buying_type", "campaign_id",
  "campaign_name", "canvas_avg_view_percent", "canvas_avg_view_time", "catalog_segment_actions", "catalog_segment_value",
  "catalog_segment_value_mobile_purchase_roas", "catalog_segment_value_omni_purchase_roas",
  "catalog_segment_value_website_purchase_roas", "clicks", "configurable_attribution_action",
  "configurable_attribution_actionvalue", "configurable_audience_overlap_reach", "configurable_audience_overlap_with_conv_action",
  "configurable_audience_overlap_with_conv_converters", "configurable_audience_overlap_with_conv_exposure_cost",
  "configurable_audience_overlap_with_conv_exposure_impressions", "configurable_audience_overlap_with_conv_exposure_reach",
  "configurable_placement_ptc_conversions", "configurable_placement_ptc_converters", "configurable_placement_ptc_reach",
  "configurable_reachbyfrequency_action", "configurable_reachbyfrequency_converters_count",
  "configurable_reachbyfrequency_impressions_cost", "configurable_reachbyfrequency_impressions_count",
  "configurable_reachbyfrequency_reach", "conversion_lead_rate", "conversion_leads", "conversion_rate_ranking",
  "conversion_values", "conversions", "converted_product_app_custom_event_fb_mobile_purchase",
  "converted_product_app_custom_event_fb_mobile_purchase_value", "converted_product_offline_purchase",
  "converted_product_offline_purchase_value", "converted_product_omni_purchase", "converted_product_omni_purchase_values",
  "converted_product_quantity", "converted_product_value", "converted_product_website_pixel_purchase",
  "converted_product_website_pixel_purchase_value", "converted_promoted_product_app_custom_event_fb_mobile_purchase",
  "converted_promoted_product_app_custom_event_fb_mobile_purchase_value", "converted_promoted_product_offline_purchase",
  "converted_promoted_product_offline_purchase_value", "converted_promoted_product_omni_purchase",
  "converted_promoted_product_omni_purchase_values", "converted_promoted_product_quantity", "converted_promoted_product_value",
  "converted_promoted_product_website_pixel_purchase", "converted_promoted_product_website_pixel_purchase_value",
  "cost_per_15_sec_video_view", "cost_per_2_sec_continuous_video_view", "cost_per_6_sec_video_view", "cost_per_action_type",
  "cost_per_ad_click", "cost_per_conversion", "cost_per_conversion_lead", "cost_per_dda_countby_convs",
  "cost_per_estimated_ad_recallers", "cost_per_inline_link_click", "cost_per_inline_post_engagement",
  "cost_per_message_delivered", "cost_per_objective_result", "cost_per_one_thousand_ad_impression", "cost_per_outbound_click",
  "cost_per_result", "cost_per_thruplay", "cost_per_unique_action_type", "cost_per_unique_click", "cost_per_unique_conversion",
  "cost_per_unique_inline_link_click", "cost_per_unique_outbound_click", "cpc", "cpm", "cpp", "created_time",
  "creative_diversity_data", "creative_diversity_label", "creative_diversity_score", "creative_fatigue_summary",
  "creative_fatigued_ads", "creative_media_type", "ctr", "date_start", "date_stop", "dda_countby_convs", "dda_results",
  "engagement_rate_ranking", "estimated_ad_recall_rate", "estimated_ad_recall_rate_lower_bound",
  "estimated_ad_recall_rate_upper_bound", "estimated_ad_recallers", "estimated_ad_recallers_lower_bound",
  "estimated_ad_recallers_upper_bound", "frequency", "full_view_impressions", "full_view_reach", "gender_targeting",
  "impressions", "inline_link_click_ctr", "inline_link_clicks", "inline_post_engagement", "instagram_profile_follow",
  "instagram_profile_visits", "instagram_upcoming_event_reminders_set", "instant_experience_clicks_to_open",
  "instant_experience_clicks_to_start", "instant_experience_outbound_clicks", "interactive_component_tap", "labels",
  "landing_page_view_actions_per_link_click", "landing_page_view_per_link_click", "landing_page_view_per_purchase_rate",
  "link_clicks_per_results", "location", "marketing_messages_click_rate_benchmark", "marketing_messages_cost_per_delivered",
  "marketing_messages_cost_per_link_btn_click", "marketing_messages_delivered", "marketing_messages_delivery_rate",
  "marketing_messages_link_btn_click", "marketing_messages_link_btn_click_rate", "marketing_messages_media_view_rate",
  "marketing_messages_phone_call_btn_click_rate", "marketing_messages_quick_reply_btn_click",
  "marketing_messages_quick_reply_btn_click_rate", "marketing_messages_read", "marketing_messages_read_rate",
  "marketing_messages_read_rate_benchmark", "marketing_messages_sent", "marketing_messages_spend",
  "marketing_messages_spend_currency", "messages_delivered", "messages_delivered_ctr", "mobile_app_purchase_roas",
  "msa_seller_budget", "multi_event_conversion_attribution_setting", "objective", "objective_result_rate", "objective_results",
  "onsite_conversion_messaging_detected_purchase_deduped", "opportunity_score_l4", "optimization_goal", "outbound_clicks",
  "outbound_clicks_ctr", "place_page_name", "playable_average_game_length", "playable_game_start_rate",
  "product_group_retailer_id", "product_retailer_id", "product_views", "purchase_per_landing_page_view", "purchase_roas",
  "purchases_per_link_click", "qualifying_question_qualify_answer_rate", "quality_ranking", "reach", "read_rate", "result_rate",
  "result_values_performance_indicator", "results", "shop_clicks", "shops_assisted_purchases", "social_spend", "spend",
  "total_card_view", "total_postbacks", "total_postbacks_detailed", "total_postbacks_detailed_v4", "unique_actions",
  "unique_clicks", "unique_conversions", "unique_ctr", "unique_inline_link_click_ctr", "unique_inline_link_clicks",
  "unique_link_clicks_ctr", "unique_outbound_clicks", "unique_outbound_clicks_ctr", "unique_video_continuous_2_sec_watched_actions",
  "unique_video_view_15_sec", "updated_time", "video_15_sec_watched_actions", "video_30_sec_watched_actions",
  "video_6_sec_watched_actions", "video_avg_time_watched_actions", "video_continuous_2_sec_watched_actions",
  "video_p100_watched_actions", "video_p25_watched_actions", "video_p50_watched_actions", "video_p75_watched_actions",
  "video_p95_watched_actions", "video_play_actions", "video_play_curve_actions", "video_play_retention_0_to_15s_actions",
  "video_play_retention_20_to_60s_actions", "video_play_retention_graph_actions", "video_thruplay_watched_actions",
  "video_time_watched_actions", "video_view_per_impression", "website_ctr", "website_purchase_roas", "wish_bid",
] as const;

/** The dates the owner can pick, as Meta names them, plus a custom range. */
export const INSIGHT_RANGES = [
  ["today", "Today"],
  ["yesterday", "Yesterday"],
  ["last_7d", "Last 7 days"],
  ["last_14d", "Last 14 days"],
  ["last_30d", "Last 30 days"],
  ["this_month", "This month"],
  ["last_month", "Last month"],
  ["maximum", "Since launch"],
] as const;
export type InsightPreset = (typeof INSIGHT_RANGES)[number][0];
export type InsightRange = { preset: InsightPreset } | { from: string; to: string };

const DAY = /^\d{4}-\d{2}-\d{2}$/;

/** A range from the query string, or null when it is not one Flashadz offers. */
export function parseRange(preset: string | null, from: string | null, to: string | null): InsightRange | null {
  if (from || to) return from && to && DAY.test(from) && DAY.test(to) && from <= to ? { from, to } : null;
  return INSIGHT_RANGES.some(([k]) => k === preset) ? { preset: preset as InsightPreset } : null;
}

/** The key a range is stored under: the preset, or `custom:<from>:<to>`. */
export const rangeKey = (r: InsightRange): string => ("preset" in r ? r.preset : `custom:${r.from}:${r.to}`);

/** One Meta value as it arrives: a number as text, a list of actions, or anything else Meta sends. */
export type MetaValue = string | number | { action_type?: string; value?: string; [k: string]: unknown }[] | Record<string, unknown> | null;
export type MetaRow = Record<string, MetaValue>;

/**
 * Meta's own "Results": what the ad set optimises for, as Meta counts it. Meta sends a list of
 * indicators, each with its values (`[{indicator: "actions:...", values: [{value: "12"}]}]`).
 */
export function metaResults(row: MetaRow | null | undefined): number {
  const v = row?.results;
  if (!Array.isArray(v)) return 0;
  let n = 0;
  for (const r of v) {
    const values = (r as { values?: { value?: string }[] }).values;
    n += Number(Array.isArray(values) ? values[0]?.value : r.value) || 0;
  }
  return n;
}

/** The number Meta sent for a field, or for one action type inside a list of actions. */
export function metaNumber(row: MetaRow | null | undefined, field: string, actionType?: string): number | null {
  const v = row?.[field];
  if (v === undefined || v === null) return null;
  if (Array.isArray(v)) {
    const hit = actionType ? v.find((a) => a.action_type === actionType) : v[0];
    return hit?.value === undefined ? null : Number(hit.value);
  }
  const n = typeof v === "number" ? v : Number(v);
  return Number.isFinite(n) ? n : null;
}
